<div id="loading" class="loading" style="display: none;"><img src="assets/image/loading.gif" alt="loading"></div>
<router-outlet></router-outlet>
